import * as React from "react";
import styled from "styled-components";
import { ConstBreakPoint } from "../../../../config/styles_const/styles_const";
import Assets from "../../../assets/img/assets";
import HeadlineLarge from "../../../common/atom/text/headline_large";

interface IProps {}

const AuthProCreateSide: React.FC<IProps> = (props) => {
  const {} = props;

  return (
    <Wrapper>
      <div style={{ display: "flex", alignItems: "flex-end" }}>
        <CreateFormTitle>新規登録</CreateFormTitle>
        <p
          style={{
            marginBottom: 5,
            marginLeft: 20,
            fontSize: 12,
            fontWeight: "bold",
            color: "#333333",
          }}
        >
          エキスパートネットワーク For Middle
        </p>
      </div>
      <CreateFormImgCenterWrapper>
        <CreateFormImg src={Assets.pro_create} />
      </CreateFormImgCenterWrapper>
    </Wrapper>
  );
};

export default AuthProCreateSide;

const Wrapper = styled.div`
  @media screen and (min-width: ${ConstBreakPoint.Default}) {
    margin-right: 20px;
    width: 50%;
  }
`;

const CreateFormImgCenterWrapper = styled.div`
  @media screen and (min-width: ${ConstBreakPoint.Default}) {
    height: 70%;
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
  }
`;

const CreateFormTitle = styled(HeadlineLarge)`
  text-align: center;
  margin-bottom: 30px;
  @media screen and (min-width: ${ConstBreakPoint.Default}) {
    text-align: left;
    margin-bottom: 0;
  }
`;

const CreateFormImg = styled.img`
  margin-bottom: 30px;
`;



// WEBPACK FOOTER //
// ./src/presentation/component/auth/pro_create/auth_pro_create_side.tsx